// extracted by mini-css-extract-plugin
export var base = "News-module--base--8a3a1";
export var container = "News-module--container--2394c";
export var content = "News-module--content--1f002";
export var date = "News-module--date--f8517";
export var header = "News-module--header--22eb3";
export var illustration = "News-module--illustration--c6146";